var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.plans.length
    ? _c(
        "action-card",
        {
          attrs: {
            title: _vm.$t("payment-plans.upcoming-payments"),
            icon: "calendar-range",
            count: _vm.plans.length
          },
          on: { open: _vm.openPlans }
        },
        _vm._l(_vm.visiblePlans, function(plan) {
          return _c(
            "button",
            {
              key: plan.id,
              staticClass: "portal-action-row",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.openPlan(plan)
                }
              }
            },
            [
              _c("span", { staticClass: "action-row-copy" }, [
                _c("strong", [
                  _vm._v(_vm._s(plan.name || _vm.$t("payment-plans.untitled")))
                ]),
                _vm.next(plan)
                  ? _c("small", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("payment-plans.remaining")) +
                          ": " +
                          _vm._s(_vm.money(plan.remaining, plan.currency)) +
                          " · " +
                          _vm._s(_vm.next(plan).label) +
                          " · " +
                          _vm._s(_vm.trigger(_vm.next(plan))) +
                          " "
                      )
                    ])
                  : _vm._e()
              ]),
              _c("portal-icon", { attrs: { name: "chevron-right", size: 18 } })
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }